<template>
  <section class="customers-read-profile">
    <former-container>
      <former-section-list
        v-for="section in visibleSections"
        :key="section.id"
        :editable="false"
        :section="section"
      >
        <template v-slot:header>
          <customers-read-resume-state
            key="resume-states"
          />
        </template>
      </former-section-list>
    </former-container>
  </section>
</template>

<script>
  import namelize from '@sdk/helpers/formatters/namelize';

  import domains from '@/helpers/apis/domains';

  import customersRead from '@/views/Customers/Form/mixin';
  import former from '@/helpers/mixins/former';

  import {
    resumeMap,
    resumePjMap,
    cellPhoneMap,
    mainPhoneMap,
  } from '@/views/Customers/Form/maps';

  import {
    sectionsPF,
    sectionsPJ,
    sectionsIDs,
  } from '@/views/Customers/Form/sections';

  import CustomersReadResumeState from '@/views/Customers/Read/Informations/Resume/State.vue';
  import FormerContainer from '@/components/Former/Container.vue';
  import FormerSectionList from '@/components/Former/Section/List.vue';

  export default {
    name: 'CustomersReadResume',
    components: {
      FormerContainer,
      FormerSectionList,

      CustomersReadResumeState,
    },
    mixins: [
      former,
      customersRead,
    ],
    props: {
      customer: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        sections: [],
      };
    },
    computed: {
      visibleSections() {
        return this.sections.map(section => ({
          ...section,
          items: section.items.filter(item => !item.skip),
        }));
      },

    },
    mounted() {
      this.getDomainsWeb().then(this.setValues);
    },
    methods: {
      setSections(isPj) {
        const map = {
          ...resumeMap,
          ...resumePjMap,
        };

        const generated = [...isPj ? sectionsPJ() : sectionsPF()];
        const personal = generated.find(section => section.id === sectionsIDs.customer_personal);

        this.sections = [{
            ...personal,
            items: personal.items.filter(item => Object.values(map).indexOf(item.id) > -1),
          },
          generated.find(section => section.id === sectionsIDs.customer_phones),
        ];

        try {
          this.gotDomainsWeb();
        } catch (err) {
          this.getDomainsWeb();
        }
      },
      setValues() {
        this.setSections(!!this.customer.cnpj);

        const {
          CELULAR,
          PRINCIPAL,
        } = domains.phone_types;

        const map = {
          ...resumeMap,
          ...resumePjMap,
        };

        if (!this.customer.social_name) {
          this.setFieldSkip(map.social_name, true);
        }

        Object.keys(map)
          .filter(key => this.getField(map[key]))
          .filter(key => ['name', 'cpf_cnpj'].indexOf(key) === -1)
          .forEach(key => this.setValue(map[key], this.customer[key]));

        this.setFieldValue(map.cpf_cnpj, this.customer.cpf || this.customer.cnpj);
        this.setFieldValue(map.name, namelize(this.customer.name));

        this.setPhoneFieldValue(
          cellPhoneMap.number,
          this.customer.phones.find(phone => phone.phone_type.name === CELULAR),
        );

        this.setPhoneFieldValue(
          mainPhoneMap.number,
          this.customer.phones.find(phone => phone.phone_type.name === PRINCIPAL),
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';
</style>
